<template>
  <v-form
    ref="form"
    v-model="valid"
    autocomplete="off"
>
    <input type="hidden" name="title" />
    <v-text-field
    v-model="form.name.first"
    :rules="rules.name.first"
    label="First Name"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.name.last"
    :rules="rules.name.last"
    label="Last Name"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.email.input"
    :rules="rules.email.input"
    label="Email"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.email.confirm"
    :rules="rules.email.confirm"
    label="Confirm Email"
    :error-messages='emailMatchError()'
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.address.line1"
    :rules="rules.address.line1"
    label="Postal Address Line 1"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.address.line2"
    label="Postal Address Line 2"
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.address.line3"
    :rules="rules.address.line3"
    label="Postal City / Town"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.address.county"
    :rules="rules.address.county"
    label="Postal County"
    required
    solo
    ></v-text-field>

    <v-text-field
    v-model="form.address.postcode"
    :rules="rules.address.postcode"
    label="Postcode"
    required
    solo
    ></v-text-field>

    <div class="v-text-field__details" v-if="androidMobile">
        <div class="v-messages theme--dark">
            <div class="v-messages__wrapper">
              <div class="v-messages__message mobile__message">
                If you're having issues uploading an image directly from your phone's camera, please save the image to your phone and upload&nbsp;it&nbsp;from&nbsp;there.                
              </div>
            </div>
        </div>
    </div>

    <div v-if="!uploadImage">
        <upload-btn
        @file-update="fileChanged"
        title="Upload your receipt"
        outline
        large
        block
        required
        color="transparent"
        dark
        accept=".png, .jpeg, .jpg, .gif, .pdf, image/*"
        capture="camera"
        >
            <template slot="icon">
                <v-icon>fas fa-upload</v-icon>
            </template>
        </upload-btn>
    </div>
    <div v-else>
        <v-img
        :src="uploadImage"
        :lazy-src="uploadImage"
        contain
        height="240"
        class="outline"
        >
        <v-btn icon right @click="removeImage" class="right remove-image">
            <v-icon light large>far fa-trash-alt</v-icon>
        </v-btn>
        </v-img>
        <h4 v-if="uploadFileName">{{uploadFileName}}</h4>
    </div>
    
    <div class="v-text-field__details" v-if="errors.receipt">
        <div class="v-messages theme--light error--text image-error">
            <div class="v-messages__wrapper">
            <div class="v-messages__message error-align" v-html="errors.receipt"></div>
            </div>
        </div>
    </div>

    <v-checkbox
    v-model="form.checkbox.confirm"
    :rules="[v => !!v || 'You must agree to continue!']"
    label="I'm 18 or over and have read and understood the Terms &amp; Conditions of the promotion. I understand that McCain will not use my personal information for any purpose other than to contact me if I win."
    required
    color="#4080c2"
    dark
    :true-value="1"
    :false-value="0"
    ></v-checkbox>
    <!-- span class="test">I confirm I am over 18, and have read the <router-link to="/privacy" target="_blank">privacy notice</router-link> and accept the <router-link to="/terms" target="_blank">terms</router-link></!-->
    <!-- div class="v-messages theme--light error--text" v-if="errors.checkbox.confirm">
        <div class="v-messages__wrapper">
            <div class="v-messages__message" v-html="errors.checkbox.confirm">
            </div>
        </div>
    </div -->

    <v-layout justify-center class="margin-top-small">
        <v-captcha class="captcha" sitekey="6LcZVrQUAAAAAIxkc4jppou2sAdpLDy-7oc5F-2N" :loadRecaptchaScript="true" @verify="captchaClick" size="100px" @expired="form.captcha = false"></v-captcha>
    </v-layout>
    <div class="v-text-field__details" v-if="errors.captcha">
        <div class="v-messages theme--light error--text shift-right-small">
        <div class="v-messages__wrapper">
            <div class="v-messages__message text-center" >{{errors.captcha}}</div>
        </div>
        </div>
    </div>

    <v-layout justify-center class="margin-top-small">
        <br />
        <v-btn 
          color="#f5b00d" 
          dark  
          @click="validate"
          :loading="loading"
          block
        >
          <span>Enter</span>
          <span slot="loader">
            <v-progress-circular
              :rotate="-90"
              :value="uploadPercentage"
              color="#fff"
            >
              {{ uploadPercentage }}
            </v-progress-circular>
            <span> Uploading images, please wait...</span>
          </span>
        </v-btn>
    </v-layout>
    
    <v-dialog
      v-model="feedbackDialog"
      max-width="290"
      >
      <v-card color="#1885ca">
          <v-card-text v-html="feedbackDialogText" class="text-center"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                  color="#f5b00d"
                  dark
                  rounded
                  min-width="100"
                  @click="feedbackDialog = false"
              >
                  Ok
              </v-btn>
              <v-spacer></v-spacer>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </v-form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import UploadButton from 'vuetify-upload-button'

export default {
  components: {
      'v-captcha' : VueRecaptcha,
      'upload-btn' : UploadButton
  },
  props: ['androidMobile'],
  data: () => ({
    valid: false,
    uploadImage: '',
    uploadFileName: false,
    uploadPercentage: 0,
    loading: false,
    form : {
        name: {
            first: '',
            last: ''
        },
        address: {
            line1: '',
            line2: '',
            line3: '',
            postcode: '',
            county: ''
        },
        checkbox: {
            confirm: 0
        },
        email : {
          input: '',
          confirm: ''
        },
        receipt: false,
        captcha: false,
        captchaToken: ''
    },
    rules : {
        name: {
            first: [
                v => !!v || 'First Name is required'
            ],
            last: [
                v => !!v || 'Last Name is required'
            ]
        },
        address : {
            line1: [
                v => !!v || 'Postal Address Line 1 is required'
            ],
            line2 : [
                v => !!v || 'Postal Address Line 2 is required'
            ],
            line3 : [
                v => !!v || 'Postal Address Line 3 is required'
            ],
            postcode: [
                v => !!v || 'Postcode is required',
                v => /^[A-Za-z]{1,2}[0-9R][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$/.test(v) || 'Please enter a valid postcode'
            ],
            county : [
                v => !!v || 'Postal County is required'
            ]
        },
        email : {
          input: [
              v => !!v || 'Email is required',
              v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
          ]
        }
    },
    errors: {
        checkbox: {
            confirm: false
        },
        image: false,
        captcha: false,
        receipt: false
    },
    feedbackDialog : false,
    feedbackDialogText : ''
  }),
  mounted () {
    let self = this
    // event handler for enter key > submit form
    window.addEventListener('keyup', function (event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            self.validate();
        }
    })
  },
  methods: {
      validate: function () {
        if(!this.form.captcha) {
          this.errors.captcha = "Please prove you are human"
        }
        this.errors.receipt = false;
        if(!this.form.receipt) {
            this.errors.receipt = "Please Upload a Receipt Image"
        }
        if (this.$refs.form.validate() && this.form.captcha && this.form.receipt) {
          var api = '/api/submitEntry',
          formData = new FormData()
          
          formData.append('firstName', this.form.name.first.trim())
          formData.append('lastName', this.form.name.last.trim())

          formData.append('address1', this.form.address.line1.trim())
          formData.append('address2', this.form.address.line2.trim())
          formData.append('address3', this.form.address.line3.trim())
          formData.append('postcode', this.form.address.postcode.trim())
          formData.append('address4', this.form.address.county.trim())

          formData.append('email', this.form.email.input.trim())

          formData.append('receipt', this.form.receipt)

          formData.append('terms', this.form.checkbox.confirm)
          formData.append('recaptcha', this.form.captchaToken)

          //console.log(formData);
          this.loading = true;
          this.axios.post(api, formData, {
            headers: {'Content-Type': 'multipart/form-data' },
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
            }).then((response)=>{
            if(response.data.success) {
              // record successfully added
              if(response.data.payload.isWin!=0) {
                // if win push->win
                this.$router.push('/win');
              }else {
                // else push->thanks
                this.$router.push('/thanks');
              }
            }else{
              this.feedbackDialogText = response.data.errors[0]                
              this.feedbackDialog = true
            }
          })
        }
      },
      captchaClick: function(recaptchaToken) {
        this.form.captcha = true
        this.errors.captcha = false
        this.form.captchaToken = recaptchaToken
        //console.log(this.captachaToken);
      },
      fileChanged : function (file) {
        //check for allowed file types
        //.png, .jpeg, .jpg, .gif, .pdf
        //console.log(file.type);
        // image/jpeg
        // image/png
        // image/gif
        // application/pdf
        if (file.type!='application/pdf'&&file.type!='image/jpeg'&&file.type!='image/png'&&file.type!='image/gif') {
          this.feedbackDialogText = "Please ensure your upload file is one of the following types: (.jpeg, .jpg, .gif, .png, .pdf)"
          this.uploadFileName = false                
          this.feedbackDialog = true
          this.uploadImage = false
          this.errors.receipt = "Unknown file type"
        }else{
          this.$refs.form.validate();
          this.errors.receipt = false;
          this.uploadFileName = false
          // Handle file as object
          // If multiple {file} is object array
          this.form.receipt = file;
          //console.log(file)
          //var image = new Image();
          var reader = new FileReader();
          var vm = this;
          // Allow for PDFs
          if(file.type == 'application/pdf') {
            // set as pdf icon
            vm.uploadImage = {src:require('@/assets/pdf_placeholder.png')}
            vm.uploadFileName = file.name
          }else{
            reader.onload = (e) => {
              vm.uploadImage = e.target.result;
            };
          }       
          reader.readAsDataURL(file);
        }
      },
      removeImage: function() {
        this.uploadImage=false
        this.form.receipt = false
      },
       emailMatchError () {
        if(this.form.email.confirm.length>0) {
          return (this.form.email.input === this.form.email.confirm) ? '' : 'Email must match'
        } 
      }
  }
};
</script>
